import React from 'react';
import { RouteFC } from 'util/routeTypes';
import { PageLayout } from 'components/PageLayout';
import { useTranslation } from 'react-i18next';
import { MerchantProvider } from 'hooks/context/merchant';
import { Optimizely } from 'hooks/context/Optimizely';
import { BasicHeader } from 'components/BasicHeader';
import Typography from 'components/Typography/Typography';
import { ExploreApp } from 'components/ExploreApp/ExploreApp';

import styles from './styles.module.scss';
import { Matryoshka } from '@clover-util/matryoshka';
import { CustomerProvider } from 'hooks/context/customer/customer';

const NOTFOUND_PROVIDERS = [
  MerchantProvider,
  CustomerProvider,
  Optimizely
];

export const NotFound: RouteFC = () => {
  const { t } = useTranslation();

  return (
    <Matryoshka wrappers={NOTFOUND_PROVIDERS}>
      <PageLayout header={<BasicHeader />} forceStandardClasses>
        <div className={styles.notFoundWrapper}>
          <Typography.Title element="h1">{t('oops')}</Typography.Title>
          <div className={styles.subHeading}>
            <Typography.Body>{t('notFound')}</Typography.Body>
          </div>
          <ExploreApp />
        </div>
      </PageLayout>
    </Matryoshka>
  );
};
